import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Container, Dropdown, Form, Modal } from "react-bootstrap";
import Card from "../../../components/Card";
import InputField from "./InputField";
import { QRCode } from "react-qrcode-logo";
import SelectField from "./SelectField";
import TextArea from "./TextArea";
import ImageUploadField from "./ImageUploadField";
import CheckboxField from "./CheckboxField";
import ReactJson from "react-json-view";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { toPng } from "html-to-image";
import download from "downloadjs";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
import { getToken } from "../../../utils/auth";
import { Country, State } from 'country-state-city';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import Canvas2Image from 'canvas2image';

const VCard = ({userData}) => {
  const [state, setState] = useState({
    value: "https://demo.dirido.com/",
    // logoImage: (!userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)
    //   ? "./diridologo.jpg" 
    //   : "",
    logoImage: "./diridologo.jpg",

    logoWidth: "36",  enableCORS: true, 
  removeQrCodeBehindLogo: true 

  }); 
    const ref = useRef();
  const [inputValue, setInputValue] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [reservedQrcIdError, setReservedQrcIdError] = useState("");
  const [secretKeyError, setSecretKeyError] = useState("");
  const [isRegisterQRSelected, setIsRegisterQRSelected] = useState(false);
  const [reservedQRCId, setReservedQRCId] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [qrCodeUrlImage, setQrCodeUrlImage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => setOpen(false);

  const handleRegisterQRChange = (e) => {
    setIsRegisterQRSelected(e.target.checked);
  };

  const handleChange = ({ target }) => {
    setState((prevState) => ({ ...prevState, [target.name]: target.value }));
  };

  // const handleDownload = () => {
  //   ref.current?.download();
  // };

  const handleDownload = async () => {
    if (ref.current) {
      try {
        // Add a small delay to ensure QR code and text are fully rendered
        setTimeout(async () => {
          const dataUrl = await toPng(ref.current, { pixelRatio: 2 });
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'qr-code-with-text.png';
          link.click();
        }, 100); // 100ms delay to ensure rendering is complete
      } catch (error) {
        console.error('Error downloading the image:', error);
      }
    }
  };

  const buildEyeRadiusInput = (id) => {
    return (
      <InputField
        name={id}
        type="range"
        handleChange={handleChange}
        min={0}
        max={50}
        hideLabel
        defaultValue={state[id]}
      />
    );
  };
  const [url, setUrl] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };

  const handlePlatformChange = (e) => {
    setSelectedPlatform(e.target.value);
  };

  // const handleButtonClick = () => {
  //   setTextAreaValue(inputValue);
  //   setState((prevState) => ({ ...prevState, value: inputValue }));
  // };
  const [selectedFile, setSelectedFile] = useState(null);
  const [qrcID, setQrcID] = useState("");
  const [qrcData, setQrcData] = useState("");
  const [selectedDesign, setSelectedDesign] = useState("design1");
  const [formData, setFormData] = useState({
    name: "",
    profileImageLink: "",
    companyName: "",
    designation: "",
    templateNumber: "",
    personalDescription: "",
    street: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    email: "",
    phone: "",
  });
  const getAddress = () => {
    const { street, city, state, zipCode, country } = formData;
    return street || city || state || zipCode || country
      ? `${street}; ${city}; ${state}; ${zipCode}; ${country}`
      : "New Delhi";
  };

  const [errors, setErrors] = useState({});

    const handlePhoneChange = (phone, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: phone,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const cardRef = useRef(null);

  const downloadCard = () => {
    if (cardRef.current) {
      toPng(cardRef.current)
        .then((dataUrl) => {
          download(dataUrl, "card.png");
        })
        .catch((err) => {
          console.error("Could not generate image", err);
          toast.error("Could not generate image");
        });
    }
  };
  // const validate = () => {

  //   const newErrors = {};
  //   if (!formData.name) newErrors.name = "Name is required";
  //   if (!formData.personalDescription)
  //     newErrors.personalDescription = "Description is required";
  //   if (!formData.email) newErrors.email = "Email is required";
  //   else if (!/\S+@\S+\.\S+/.test(formData.email))
  //     newErrors.email = "Email is invalid";
  //   if (!formData.phone) newErrors.phone = "Phone number is required";
  //   else if (!/^\d{10}$/.test(formData.phone))
  //     newErrors.phone = "Phone number should be 10 digits";
  //   if (!formData.companyName)
  //     newErrors.companyName = "Company name is required";
  //   if (!formData.designation)
  //     newErrors.designation = "Designation is required";
  //   if (!formData.street) newErrors.street = "Street is required";
  //   if (!formData.city) newErrors.city = "City is required";
  //   if (!formData.state) newErrors.state = "State is required";
  //   if (!formData.country) newErrors.country = "Country is required";
  //   if (!formData.zipCode) newErrors.zipCode = "PinCode is required";
  //   else if (!/^\d{6}$/.test(formData.zipCode))
  //     newErrors.zipCode = "PinCode should be 6 digits";
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

const validate = () => {
  const newErrors = {};

                const MAX_SIZE = 1 * 1024 * 1024;
   if (selectedFile) {
  if (selectedFile.size > MAX_SIZE) {
    toast.error("File size must not exceed 1MB");
    return;
  }
}

  if (!formData.name) {
  newErrors.name = "Name is required";
} else if (!formData.personalDescription) {
  newErrors.personalDescription = "Description is required";
} else if (!formData.email) {
  newErrors.email = "Email is required";
} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
  newErrors.email = "Email is invalid";
} else if (!formData.phone) {
  newErrors.phone = "Phone number is required";
} else if (!formData.companyName) {
  newErrors.companyName = "Company name is required";
} else if (!formData.designation) {
  newErrors.designation = "Designation is required";
} else if (!formData.street) {
  newErrors.street = "Street is required";
} else if (!formData.city) {
  newErrors.city = "City is required";
} else if (!formData.state) {
  newErrors.state = "State is required";
} else if (!formData.country) {
  newErrors.country = "Country is required";
} else if (!formData.zipCode) {
  newErrors.zipCode = "PinCode is required";
} else if (!/^\d{6}$/.test(formData.zipCode)) {
  newErrors.zipCode = "PinCode should be 6 digits";
}

// if there’s any error, show only one toast
if (Object.keys(newErrors).length > 0) {
  const firstError = Object.values(newErrors)[0];
  toast.error(firstError);
  setErrors(newErrors);
  return;
}

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const [selectedShowFile, setSelectedShowFile] = useState(null);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    const file = event.target.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      setSelectedShowFile(fileUrl);
    }
  };

 
  const handleQRC = async () => {
    if (!validate()) {
      return;
    }
//               const MAX_SIZE = 1 * 1024 * 1024;
//    if (selectedFile) {
//   if (selectedFile.size > MAX_SIZE) {
//     toast.error("File size must not exceed 1MB");
//     return;
//   }
// }
    try {
      const token = getToken();
      setLoading(true); 

      let profileImageLink = formData.profileImageLink;



      if (selectedFile) {
        const uploadFormData = new FormData();
        uploadFormData.append("file", selectedFile);
        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_URL}/api/file/upload`,
          uploadFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        profileImageLink = uploadResponse.data.data;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/generate`,
        {
          qrcCategory: "v-card",
          vCardData: {
            name: formData.name,
            profileImageLink: profileImageLink,
            companyName: formData.companyName,
            designation: formData.designation,
            templateNumber: selectedDesign,
            personalDescription: formData.personalDescription,
            address: {
              street: formData.street,
              city: formData.city,
              state: formData.state,
              country: formData.country,
              zipCode: formData.zipCode,
            },
            contactInfo: {
              email: formData.email,
              phone: formData.phone,
            },
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setQrcID(response.data.data.qrcId);
      setQrcData(response.data.data.qrCodeData);
      handleButtonClick(response.data.data.qrCodeData, response.data.data.qrcId);
    } catch (error) {
      console.log("Error generating QR", error);
      toast.error(error?.response?.data.message || error?.uploadResponse?.data?.message);
      setLoading(false);
    } 
  };
  const handleQRCRegister = async () => {
    if (isRegisterQRSelected) {
      if (!reservedQRCId) {
        setReservedQrcIdError("Reserved QRC ID is required.");
        return;
      }
      if (!secretKey) {
        setSecretKeyError("Secret Key is required.");
        return;
      }
    }
    if (!validate()) {
      return;
    }
//        const MAX_SIZE = 1 * 1024 * 1024;
// if (selectedFile) {
//   if (selectedFile.size > MAX_SIZE) {
//     toast.error("File size must not exceed 1MB");
//     return;
//   }
// }
    setLoading(true); 
    try {
      const token = getToken();
      let profileImageLink = formData.profileImageLink;



      if (selectedFile) {
        const uploadFormData = new FormData();
        uploadFormData.append("file", selectedFile);
        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_URL}/api/file/upload`,
          uploadFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        profileImageLink = uploadResponse.data.data;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/generate`,
        {
          qrcCategory: "v-card",
          isReserved: true,
          reservedQrcId: reservedQRCId,
          secretKey: secretKey,
          vCardData: {
            name: formData.name,
            profileImageLink: profileImageLink,
            companyName: formData.companyName,
            designation: formData.designation,
            templateNumber: selectedDesign,
            personalDescription: formData.personalDescription,
            address: {
              street: formData.street,
              city: formData.city,
              state: formData.state,
              country: formData.country,
              zipCode: formData.zipCode,
            },
            contactInfo: {
              email: formData.email,
              phone: formData.phone,
            },
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setQrcID(response.data.data.qrcId);
      setQrcData(response.data.data.qrCodeData);
      handleButtonClick(response.data.data.qrCodeData, response.data.data.qrcId);
    } catch (error) {
      console.log("Error generating QR", error);
      toast.error(error.response.data.message);
      setLoading(false);
    } 
  };
  const handleButtonClick = (qrlink, qrid) => {
     setLoading(true);
    setState((prevState) => ({ ...prevState, value: qrlink }));
    handleUpdateQRCode(qrid);
  };

    // const handleUpdateQRCode = async (qrid) => {
    //   if (ref.current) {
    //     setLoading(true);
    //     try {
    //       setTimeout(async () => {
    //         const dataUrl = await toPng(ref.current, { pixelRatio: 2 });
    //             const base64Data = dataUrl.split(",")[1];
    //             updateQRCode(base64Data, qrid);
    //       }, 200); 
    //     } catch (error) {
    //       console.error("Error processing QR image:", error);
    //       setLoading(false);
    //     }
    //   }
    // };

      const handleUpdateQRCode = async (qrid) => {
  if (ref.current) {
    try {
      setLoading(true);
      
      setTimeout(async () => {
        // Get the canvas from QRCode component
        const canvas = ref.current.querySelector('canvas');
        
        if (canvas) {
          // Convert canvas to blob (better iOS support)
          canvas.toBlob(async (blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Data = reader.result.split(',')[1];
              updateQRCode(base64Data, qrid);
            };
            reader.readAsDataURL(blob);
          }, 'image/png');
        }
      }, 500);
    } catch (error) {
      setLoading(false);
      console.error("Error processing QR image:", error);
    }
  }
};

    const updateQRCode = async (base64Data, qrcId) => {
      try {
        const token = getToken();
        setLoading(true); 
        const putPayload = {
          qrCodeUrl: `data:image/png;base64,${base64Data}`,
        };
    
        await axios.put(
          `${process.env.REACT_APP_URL}/api/qrc/social-net/${qrcId}`,
          putPayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        toast.success("QR Code generated successfully!");
        setQrCodeUrlImage(`data:image/png;base64,${base64Data}`);
        setOpen(true); 
        setFormData({
              name: "",
    profileImageLink: "",
    companyName: "",
    designation: "",
    templateNumber: "",
    personalDescription: "",
    street: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    email: "",
    phone: "",
        })
      } catch (error) {
        console.error("Error updating QR Code:", error);
        toast.error(error?.response?.data?.message ||"Failed to update QR Code.");
      }  finally {
        setLoading(false);
      }
    };

    const getCountryCodeByName = (countryName) => {
      const country = Country.getAllCountries().find(
        (c) => c.name === countryName
      );
      return country?.isoCode || "";
    };
      const [user, setUser] = useState("");
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("user details header", response.data.data);
      setUser(response?.data?.data);
      const countryCode = response?.data?.data?.country || "";
            const countryInfo = Country.getCountryByCode(countryCode);
            const countryNameFromList = countryInfo?.name || "";
            // setCountryName(countryNameFromList)
            setFormData((prev) => ({ ...prev, country: countryNameFromList }));

    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  
  useEffect(() => {
      fetchUserData();
  },[])

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{loading && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
        <>
          <Row style={{display:"flex", flexWrap:"wrap"}}>
            <Col lg={8} className="row m-0 p-0">
              <Col sm={12}>
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                  <div>
                    <div className="containerqrc">
                      <div className="contqrc">
                        <div style={{ marginBottom: "10px" }}>
                          <span className="stepbutton">{t('step')} 1</span>
                          <span className="steplabel">{t('enter_details')}</span>
                        </div>
                        <div>
                          <div>
                          <div style={{ marginBottom: "10px" }}>
          <label>
            <input
              type="checkbox"
              checked={isRegisterQRSelected}
              onChange={handleRegisterQRChange}
            />
            {t('register_qr')}
          </label>
        </div>
        {isRegisterQRSelected && (
        <>
        <div>
                              <label style={{ fontSize: "18px" }}>
                              {t('reserved_qrc_id')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                value={reservedQRCId}
                onChange={(e) => setReservedQRCId(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {reservedQrcIdError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {reservedQrcIdError}
              </div>
            )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                              {t('secret_key')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                value={secretKey}
                onChange={(e) => setSecretKey(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {secretKeyError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {secretKeyError}
              </div>
            )}
                            </div>
                            </>)}
                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('name_label')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.name && (
                                <p style={{ color: "red" }}>{errors.name}</p>
                              )}
                            </div>
                            <label
                    htmlFor="file-input"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                     <label style={{ fontSize: "18px" }}>
                                {t('profile_photo')}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                    <div
                      className="bg-soft-primary rounded p-1 pointer"
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "1.2rem",
                        position: "relative",
                        borderRadius: "10px",
                      }}
                    >
                      <input
                        id="file-input"
                        type="file"
                        name="image"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <span>
                        <i className="fas fa-upload"></i>
                      </span>
                      <p style={{ marginTop: ".5rem" }}>
                        {t('click_to_select_files')}
                      </p>
                    </div>
                    {selectedFile && (
                      <div style={{ marginTop: "10px", textAlign: "center" }}>
                        {t('selected_file')} - {selectedFile.name}
                      </div>
                    )}
                  </label>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('description')}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <textarea
                                type="text"
                                name="personalDescription"
                                value={formData.personalDescription}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.personalDescription && (
                                <p style={{ color: "red" }}>
                                  {errors.personalDescription}
                                </p>
                              )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('email_label')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.email && (
                                <p style={{ color: "red" }}>{errors.email}</p>
                              )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('phone_label')} <span style={{ color: "red" }}>*</span>
                              </label>
                              {/* <input
                                type="number"
                                name="phone"
                                value={formData.phone}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              /> */}
                                     <PhoneInput
          country={(user?.country || "us").toLowerCase()}
          value={formData.phone}
          onChange={(phone) => handlePhoneChange(phone, "phone")}
          inputStyle={{
            width: "100%",
            paddingBlock: "20px",
            borderRadius: "5px",
            border: "1px solid #d4d4d4",
          }}
          required
        />
                              {errors.phone && (
                                <p style={{ color: "red" }}>{errors.phone}</p>
                              )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('company')}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="companyName"
                                value={formData.companyName}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.companyName && (
                                <p style={{ color: "red" }}>
                                  {errors.companyName}
                                </p>
                              )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('designation')}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="designation"
                                value={formData.designation}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.designation && (
                                <p style={{ color: "red" }}>
                                  {errors.designation}
                                </p>
                              )}
                            </div>

                            <div>
                              <label style={{ fontSize: "18px" }}>
                                {t('street')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="street"
                                value={formData.street}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.street && (
                                <p style={{ color: "red" }}>{errors.street}</p>
                              )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                              {t('city')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.city && (
                                <p style={{ color: "red" }}>{errors.city}</p>
                              )}
                            </div>
                                                      <div>
                                 <Form.Group className="form-group">
                                      <Form.Label style={{ fontSize: "18px" }}>
                                        {t("country")} <span style={{ color: "red" }}>*</span>{" "}
                                      </Form.Label>
                                      <Form.Select
                                        name="country"
                                        value={formData.country}
                                      //  onChange={handleInputChange}
                                      onChange={(e) => {
            const selectedCountryName = e.target.value;
            setFormData({
              ...formData,
              country: selectedCountryName,
              state: "",
            });
          }}
                                        className="mb-0 py-2"
                                        required
                                      >
                                        <option value="">{t("selectCountry")}</option>
                                        {Country.getAllCountries().map((country) => (
                                          <option key={country.isoCode} value={country.name}>
                                            {country.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Form.Group>
                              {errors.country && (
                                <p style={{ color: "red" }}>{errors.country}</p>
                              )}
                            </div>
                            <div>
                                <Form.Group className="form-group">
                                      <Form.Label style={{ fontSize: "18px" }}>
                                        {t("state")} <span style={{ color: "red" }}>*</span>{" "}
                                      </Form.Label>
                                      <Form.Select
                                        name="state"
                                        value={formData.state}
                                        onChange={handleInputChange}
                                        className="mb-0 py-2"
                                        required
                                        disabled={!formData.country}
                                      >
                                        <option value="">{t("selectState")}</option>
                                        {formData.country &&
                                          State.getStatesOfCountry(getCountryCodeByName(formData.country)).map(
                                            (state) => (
                                              <option key={state.isoCode} value={state.name}>
                                                {state.name}
                                              </option>
                                            )
                                          )}
                                      </Form.Select>
                                    </Form.Group>
                              {errors.state && (
                                <p style={{ color: "red" }}>{errors.state}</p>
                              )}
                            </div>
  
                            <div>
                              <label style={{ fontSize: "18px" }}>
                              {t('pincode')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                name="zipCode"
                                value={formData.zipCode}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {errors.zipCode && (
                                <p style={{ color: "red" }}>{errors.zipCode}</p>
                              )}
                            </div>
                            {/* <div style={{ display: "flex" }}>
                              {isRegisterQRSelected ? (
                                <button
                                className="btn btn-primary d-block "
                                style={{
                                  display: "flex",
                                  width: "200px",
                                  marginInline: "auto",
                                }}
                                onClick={handleQRCRegister}
                              >
                                {t('generate_qr_code')}
                              </button>
                              ):(
<button
                                className="btn btn-primary d-block "
                                style={{
                                  display: "flex",
                                  width: "200px",
                                  marginInline: "auto",
                                }}
                                onClick={handleQRC}
                              >
                                {t('generate_qr_code')}
                              </button>
                              )}
                              
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="contqrcsecond">
                        <div className="section" style={{ width: "100%" }}>
                          <div>
                            <span className="stepbutton">{t('step')} 2</span>
                            <span className="steplabel">{t('customize_qr_code')}</span>
                          </div>
                          {/* Upper Properties */}
                          <div className="containerproperties">
                            <div className="subcontainer">
                              <div className="properties">
                                <SelectField
                                  name="qrStyle"
                                  options={["squares", "dots", "fluid"]}
                                  handleChange={handleChange}
                                  label={t('qr_style')}
                                />
                              </div>
                              <div className="properties" style={{
    pointerEvents: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 'none' : 'auto',
    opacity: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 0.5 : 1
  }}>
                                <ImageUploadField
                                  name="logoImage"
                                  handleChange={handleChange}
                                  label={t('logo_image')}
                                />
                              </div>
                              <InputField
                                name="logoWidth"
                                type="range"
                                handleChange={handleChange}
                                min={10}
                    max={40}
                    label={t('logo_width')}
                              />

                              <InputField
                                name="logoPadding"
                                type="range"
                                handleChange={handleChange}
                                min={0}
                                max={20}
                                step={1}
                                defaultValue={0}
                                label={t('logo_padding')}
                              />
                            </div>
                            <div className="subcontainer">
                              <div className="properties">
                                <SelectField
                                  name="logoPaddingStyle"
                                  options={["square", "circle"]}
                                  handleChange={handleChange}
                                  label={t('logo_padding_style')}
                                />
                              </div>

                              <div
                                className="properties"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-around",
                                }}
                              >
                                <InputField
                                  name="bgColor"
                                  type="color"
                                  defaultValue="#ffffff"
                                  handleChange={handleChange}
                                  label={t('bg_color')}
                                />
                                <InputField
                                  name="fgColor"
                                  type="color"
                                  defaultValue="#000000"
                                  handleChange={handleChange}
                                  label={t('fg_color')}
                                />
                              </div>
                              <InputField
                                name="logoHeight"
                                type="range"
                                handleChange={handleChange}
                                min={10}
                                max={40}
                                label={t('logo_height')}
                              />
                              <InputField
                                name="quietZone"
                                type="range"
                                handleChange={handleChange}
                                min={20}
                                max={80}
                                label={t('quiet_zone')}
                              />
                            </div>
                            <div className="subcontainer">
                              <div className="properties">
                                <SelectField
                                  name="ecLevel"
                                  options={["L", "M", "Q", "H"]}
                                  handleChange={handleChange}
                                  label={t('ec_level')}
                                />
                              </div>
                              <div className="properties">
                                {/* <CheckboxField
                                  name=" removeQrCodeBehindLogo"
                                  handleChange={handleChange}
                                  label={t('remove_qr_code_behind_logo')}
                                /> */}
                                <CheckboxField
                                  name=" enableCORS"
                                  handleChange={handleChange}
                                  label={t('enable_cors')}
                                />
                              </div>
                              <div className="properties" style={{
    pointerEvents: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 'none' : 'auto',
    opacity: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 0.5 : 1
  }}>
                              <InputField
                                name="logoOpacity"
                                type="range"
                                handleChange={handleChange}
                                min={0}
                                max={1}
                                step={0.1}
                                defaultValue={1}
                                label={t('logo_opacity')}
                              />
</div>
                              <InputField
                                name="size"
                                type="range"
                                handleChange={handleChange}
                                min={100}
                                max={220}
                                label={t('range')}
                              />
                            </div>
                          </div>

                          {/* QR Code  */}
                          <div 
                 style={{
                  width: 300,
                  border:"2px solid red",
                  marginInline: "auto",
                  height: 300, 
                  padding: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '1px solid #d4fafc',
                  borderRadius: '50px',
                  backgroundColor: '#d4fafc',}}
              >
                <div ref={ref} style={{ display:"flex", flexDirection:"column"}}>
                <QRCode
                   style={{display:"flex"}}
                  logoOnLoad={(e) => console.log("logo loaded", e)}
                  {...{
                    ...state,
                    eyeRadius: [
                      // build eyeRadius manually
                      {
                        outer: [
                          state.eyeradius_0_outer_0,
                          state.eyeradius_0_outer_1,
                          state.eyeradius_0_outer_2,
                          state.eyeradius_0_outer_3,
                        ],
                        inner: [
                          state.eyeradius_0_inner_0,
                          state.eyeradius_0_inner_1,
                          state.eyeradius_0_inner_2,
                          state.eyeradius_0_inner_3,
                        ],
                      },
                      {
                        outer: [
                          state.eyeradius_1_outer_0,
                          state.eyeradius_1_outer_1,
                          state.eyeradius_1_outer_2,
                          state.eyeradius_1_outer_3,
                        ],
                        inner: [
                          state.eyeradius_1_inner_0,
                          state.eyeradius_1_inner_1,
                          state.eyeradius_1_inner_2,
                          state.eyeradius_1_inner_3,
                        ],
                      },
                      {
                        outer: [
                          state.eyeradius_2_outer_0,
                          state.eyeradius_2_outer_1,
                          state.eyeradius_2_outer_2,
                          state.eyeradius_2_outer_3,
                        ],
                        inner: [
                          state.eyeradius_2_inner_0,
                          state.eyeradius_2_inner_1,
                          state.eyeradius_2_inner_2,
                          state.eyeradius_2_inner_3,
                        ],
                      },
                    ],
                    eyeColor: [
                      // build eyeColor manually
                      {
                        outer:
                          state.eyecolor_0_outer ?? state.fgColor ?? "#000000",
                        inner:
                          state.eyecolor_0_inner ?? state.fgColor ?? "#000000",
                      },
                      {
                        outer:
                          state.eyecolor_1_outer ?? state.fgColor ?? "#000000",
                        inner:
                          state.eyecolor_1_inner ?? state.fgColor ?? "#000000",
                      },
                      {
                        outer:
                          state.eyecolor_2_outer ?? state.fgColor ?? "#000000",
                        inner:
                          state.eyecolor_2_inner ?? state.fgColor ?? "#000000",
                      },
                    ],
                  }}
                />
                                  {isRegisterQRSelected && (
                <div style={{display:"flex", fontSize:"18px", justifyContent:"center",fontWeight:"600", background:"#fff", marginTop:"-10px" }}>{reservedQRCId}</div>
                )}
                {/* {(userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid) && (
  <div style={{ display: "flex", justifyContent: "center", fontSize: "10px", background:"#fff", marginTop:"-5px" }}>
    www.dirido.com
  </div>
)} */}
                </div>
              </div>
                          <div
                            className="app"
                            style={{ background: "#fff", borderRadius: "5px" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                className="containerproperties1"
                                style={{ flexDirection: "column" }}
                              >
                                <div
                                  className="subcontainer1"
                                  style={{ width: "100%" }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "500",
                                      fontSize: "18px",
                                    }}
                                  >
                                    {t('eye_radius')}
                                  </p>
                                                   <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    gap: 24,
  }}
>
  {/* Top Left Eye */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #ddd",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
      {t("top_left_eye")}
    </div>

    <div style={{ display: "flex", gap: 16 }}>
      {/* Outer */}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("outer")}</div>
        {buildEyeRadiusInput("eyeradius_0_outer_0")}
        {buildEyeRadiusInput("eyeradius_0_outer_1")}
        {buildEyeRadiusInput("eyeradius_0_outer_2")}
        {buildEyeRadiusInput("eyeradius_0_outer_3")}
      </div>

      {/* Inner */}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("inner")}</div>
        {buildEyeRadiusInput("eyeradius_0_inner_0")}
        {buildEyeRadiusInput("eyeradius_0_inner_1")}
        {buildEyeRadiusInput("eyeradius_0_inner_2")}
        {buildEyeRadiusInput("eyeradius_0_inner_3")}
      </div>
    </div>
  </div>

  {/* Top Right Eye */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #ddd",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
      {t("top_right_eye")}
    </div>

    <div style={{ display: "flex", gap: 16 }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("outer")}</div>
        {buildEyeRadiusInput("eyeradius_1_outer_0")}
        {buildEyeRadiusInput("eyeradius_1_outer_1")}
        {buildEyeRadiusInput("eyeradius_1_outer_2")}
        {buildEyeRadiusInput("eyeradius_1_outer_3")}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("inner")}</div>
        {buildEyeRadiusInput("eyeradius_1_inner_0")}
        {buildEyeRadiusInput("eyeradius_1_inner_1")}
        {buildEyeRadiusInput("eyeradius_1_inner_2")}
        {buildEyeRadiusInput("eyeradius_1_inner_3")}
      </div>
    </div>
  </div>

  {/* Bottom Left Eye */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #ddd",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
      {t("bottom_left_eye")}
    </div>

    <div style={{ display: "flex", gap: 16 }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("outer")}</div>
        {buildEyeRadiusInput("eyeradius_2_outer_0")}
        {buildEyeRadiusInput("eyeradius_2_outer_1")}
        {buildEyeRadiusInput("eyeradius_2_outer_2")}
        {buildEyeRadiusInput("eyeradius_2_outer_3")}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("inner")}</div>
        {buildEyeRadiusInput("eyeradius_2_inner_0")}
        {buildEyeRadiusInput("eyeradius_2_inner_1")}
        {buildEyeRadiusInput("eyeradius_2_inner_2")}
        {buildEyeRadiusInput("eyeradius_2_inner_3")}
      </div>
    </div>
  </div>
</div>
                                </div>
                                <div
                                  className="subcontainer1"
                                  style={{ width: "100%" }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "500",
                                      fontSize: "18px",
                                    }}
                                  >
                                    {t('eye_color')}
                                  </p>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-evenly",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div style={{ fontSize: 14 }}>
                                        {t('top_left_eye')}
                                      </div>
                                      <div style={{ fontSize: 12 }}>{t('outer')}</div>
                                      <InputField
                                        name="eyecolor_0_outer"
                                        type="color"
                                        defaultValue={
                                          state.fgColor ?? "#000000"
                                        }
                                        handleChange={handleChange}
                                        hideLabel={true}
                                      />
                                      <div style={{ fontSize: 12 }}>{t('inner')}</div>
                                      <InputField
                                        name="eyecolor_0_inner"
                                        type="color"
                                        defaultValue={
                                          state.fgColor ?? "#000000"
                                        }
                                        handleChange={handleChange}
                                        hideLabel={true}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div style={{ fontSize: 14 }}>
                                        {t('top_right_eye')}
                                      </div>
                                      <div style={{ fontSize: 12 }}>{t('outer')}</div>
                                      <InputField
                                        name="eyecolor_1_outer"
                                        type="color"
                                        defaultValue={
                                          state.fgColor ?? "#000000"
                                        }
                                        handleChange={handleChange}
                                        hideLabel={true}
                                      />
                                      <div style={{ fontSize: 12 }}>{t('inner')}</div>
                                      <InputField
                                        name="eyecolor_1_inner"
                                        type="color"
                                        defaultValue={
                                          state.fgColor ?? "#000000"
                                        }
                                        handleChange={handleChange}
                                        hideLabel={true}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div style={{ fontSize: 14 }}>
                                        {t('bottom_left_eye')}
                                      </div>
                                      <div style={{ fontSize: 12 }}>{t('outer')}</div>
                                      <InputField
                                        name="eyecolor_2_outer"
                                        type="color"
                                        defaultValue={
                                          state.fgColor ?? "#000000"
                                        }
                                        handleChange={handleChange}
                                        hideLabel={true}
                                      />
                                      <div style={{ fontSize: 12 }}>{t('inner')}</div>
                                      <InputField
                                        name="eyecolor_2_inner"
                                        type="color"
                                        defaultValue={
                                          state.fgColor ?? "#000000"
                                        }
                                        handleChange={handleChange}
                                        hideLabel={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div style={{ display: "flex" }}>
                              <button
                                className="btn btn-primary d-block "
                                style={{
                                  display: "flex",
                                  width: "200px",
                                  marginInline: "auto",
                                }}
                                onClick={handleDownload}
                              >
                                {t('download_qr_code')}
                              </button>
                            </div> */}
                             <div style={{ display: "flex" }}>
                              {isRegisterQRSelected ? (
                                <button
                                className="btn btn-primary d-block "
                                style={{
                                  display: "flex",
                                  width: "200px",
                                  marginInline: "auto",
                                }}
                                onClick={handleQRCRegister}
                              >
                                {t('generate_qr_code')}
                              </button>
                              ):(
<button
                                className="btn btn-primary d-block "
                                style={{
                                  display: "flex",
                                  width: "200px",
                                  marginInline: "auto",
                                }}
                                onClick={handleQRC}
                              >
                                {t('generate_qr_code')}
                              </button>
                              )}
                              
                            </div>
                            {/* <button
          type="button"
          onClick={handleDownload}
          style={{ margin: "20px" }}
        >
          {t('download_qr_code')}
        </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            </Col>
        <Col xs={12} lg={4} className="m-0 p-0">
              {/* <Card
                id="post-modal-data"
                className="card-block card-stretch card-height"
              > */}
                <div
                  style={{ width: "100%", display: "flex", paddingTop: "10px" }}
                >
                  <label
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "center",
                      gap: "6px",
                      fontSize: "16px",
                    }}
                  >
                    <input
                      type="radio"
                      name="design"
                      value="design1"
                      checked={selectedDesign === "design1"}
                      onChange={() => setSelectedDesign("design1")}
                    />
                    {t('design')} 1
                  </label>
                  <label
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "center",
                      gap: "6px",
                      fontSize: "16px",
                    }}
                  >
                    <input
                      type="radio"
                      name="design"
                      value="design2"
                      checked={selectedDesign === "design2"}
                      onChange={() => setSelectedDesign("design2")}
                    />
                    {t('design')} 2
                  </label>
                </div>
                <div ref={cardRef}>
                  {/* First Card */}
                  {selectedDesign === "design1" && (
                    <div
                      style={{
                        border: "1px solid #d4d4d4",
                        margin: "7px",
                        borderRadius: "10px",
                        background: "rgb(231,238,243)",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "10px",
                          paddingBlock: "10px",
                          background: "rgb(66,128,231)",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <img
                          src={selectedShowFile|| "/profile.png"}
                          style={{
                            display: "flex",
                            width: "80px",
                            marginInline: "auto",
                            borderRadius: "100px",
                            border: "3px solid #fff",
                            marginTop: "10px",
                          }}
                          alt="Profile"
                        />
                        <label
                          style={{
                            display: "flex",
                            marginInline: "auto",
                            fontSize: "14px",
                            color: "#fff",
                          }}
                        >
                          {formData.name || "John Doe"}
                        </label>
                        <label
                          style={{
                            display: "flex",
                            marginInline: "auto",
                            fontSize: "12px",
                            color: "#fff",
                          }}
                        >
                          {formData.designation || "Position"}
                        </label>
                        <label
                          style={{
                            display: "flex",
                            marginInline: "auto",
                            fontSize: "12px",
                            color: "#fff",
                          }}
                        >
                          {formData.companyName || "Company"}
                        </label>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          paddingInline: "10px",
                          borderRadius: "5px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          marginInline: "8px",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('description')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.personalDescription || "Personal Info"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          paddingInline: "10px",
                          borderRadius: "5px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          marginInline: "8px",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                          {t('email_label')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.email || "john@gmail.com"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          paddingInline: "10px",
                          borderRadius: "5px",
                          marginBottom: "8px",
                          marginInline: "8px",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('phone_label')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.phone || "9090909090"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          paddingInline: "10px",
                          borderRadius: "5px",
                          marginBottom: "8px",
                          marginInline: "8px",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('company')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.companyName || "Company Name"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          paddingInline: "10px",
                          borderRadius: "5px",
                          marginBottom: "8px",
                          marginInline: "8px",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('position')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.designation || "Position"}
                        </div>
                      </div>
                      {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    background: "white",
                    paddingInline: "10px",
                    borderRadius: "5px",
                    marginBottom: "8px",
                    marginInline: "8px",
                  }}
                >
                  <div style={{ display: "flex", fontWeight: "600" }}>Website :</div>
                  <div style={{ display: "flex" }}>
                    {formData.website || "https://www.website.com"}
                  </div>
                </div> */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          paddingInline: "10px",
                          borderRadius: "5px",
                          marginInline: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('address')} :
                        </div>
                        <div style={{ display: "flex" }}>{getAddress()}</div>
                      </div>
                    </div>
                  )}
                  {/* Second Card */}
                  {selectedDesign === "design2" && (
                    <div
                      style={{
                        border: "1px solid #d4d4d4",
                        margin: "7px",
                        borderRadius: "10px",
                        background: "rgb(231,238,243)",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <img
                        src={selectedShowFile || "/profile.png"}
                        style={{
                          display: "flex",
                          width: "100px",
                          marginInline: "auto",
                          borderRadius: "100px",
                          border: "3px solid #fff",
                          marginTop: "10px",
                          position: "relative",
                        }}
                        alt="Profile"
                      />
                      <div
                        style={{
                          overflow: "hidden",
                          borderRadius: "10px",
                          paddingBlock: "10px",
                          background: "rgb(66,128,231)",
                          marginInline: "10px",
                          display: "flex",
                          paddingTop: "60px",
                          marginTop: "-51px",
                          flexDirection: "column",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            marginInline: "auto",
                            fontSize: "14px",
                            color: "#fff",
                          }}
                        >
                          {formData.name || "John Doe"}
                        </label>
                        <label
                          style={{
                            display: "flex",
                            marginInline: "auto",
                            fontSize: "12px",
                            color: "#fff",
                          }}
                        >
                          {formData.designation || "Position"}
                        </label>
                        <label
                          style={{
                            display: "flex",
                            marginInline: "auto",
                            fontSize: "12px",
                            color: "#fff",
                          }}
                        >
                          {formData.companyName || "Company"}
                        </label>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingInline: "10px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          borderBottom: "1px solid #d4d4d4",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('description')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.personalDescription || "Personal Info"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingInline: "10px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          borderBottom: "1px solid #d4d4d4",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                          {t('email_label')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.email || "john@gmail.com"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingInline: "10px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          borderBottom: "1px solid #d4d4d4",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('phone_label')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.phone || "9090909090"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingInline: "10px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          borderBottom: "1px solid #d4d4d4",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('company')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.companyName || "Company Name"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingInline: "10px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          borderBottom: "1px solid #d4d4d4",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('position')} :
                        </div>
                        <div style={{ display: "flex" }}>
                          {formData.designation || "Position"}
                        </div>
                      </div>
                      {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingInline: "10px",
                    marginBottom: "8px",
                    marginTop: "8px",
                    borderBottom:"1px solid #d4d4d4",
                  }}
                >
                  <div style={{ display: "flex", fontWeight: "600" }}>Website :</div>
                  <div style={{ display: "flex" }}>
                    {formData.website || "https://www.website.com"}
                  </div>
                </div> */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingInline: "10px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          borderBottom: "1px solid #d4d4d4",
                        }}
                      >
                        <div style={{ display: "flex", fontWeight: "600" }}>
                        {t('address')} :
                        </div>
                        <div style={{ display: "flex" }}>{getAddress()}</div>
                      </div>
                    </div>
                  )}
                </div>
                <button
                  className="btn btn-primary d-block "
                  style={{
                    display: "flex",
                    width: "200px",
                    marginInline: "auto",
                  }}
                  onClick={downloadCard}
                >
                  {t('download_card')}
                </button>
              {/* </Card> */}
            </Col>
          </Row>
        </>
      {/* <Footer/> */}
      <Modal show={open} onHide={handleClose} centered>
      <button
    onClick={handleClose}
    style={{
      position: "absolute",
      top: "10px",
      right: "15px",
      background: "none",
      border: "none",
      cursor: "pointer",
      fontSize: "20px",
      zIndex: "1050",
    }}
  >
    <AiOutlineClose />
  </button>
        <Modal.Body>
          <Container className="text-center p-4">
            {qrCodeUrlImage ? (
              <>
                <h5 className="mb-3">{t("qrGeneratedSuccessfully")}</h5>
                <img src={qrCodeUrlImage} alt="Generated QR Code" width="200" />
                <Row className="mt-3">
                  <Col>
                    <button
                      className="btn btn-primary w-100" style={{marginTop:"10px"}}
                      onClick={handleDownload}
                    >
                      {t("download_qr_code")}
                    </button>
                  </Col>
                </Row>
              </>
            ) : (
              <h5>{t("failedToLoadQrCode")}</h5>
            )}
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default VCard;
